export default __webpack_public_path__ + "static/media/investors_logo14.0471bb68.png";